/**
 * «БОРЛУУЛАЛТЫН БАГ (МАРШРУТ)» — НЭГ ОЙЛГОЛТ (docs/31 §4w, эзэмшигч 2026-09-27).
 *
 * ! `/bi/sales` дээрх «Үндсэн менежер» (`manager` — харилцагчийн ОсновнойМенеджер) ба «Борлуулалтын баг (1С хэрэглэгч)»
 * ! (`salesManager` — баримтын толгойн Менеджер) нь 1С-ийн НЭГ лавлахыг (`Справочник.Пользователи`, `_Reference165`) заадаг
 * ! НЭГ ойлголт. Жагсаалтын ЗӨВ эх сурвалж нь `/erp/routes` (bridge `references/routes`: `_Marked = 0` БА `maxUseMobileApp`).
 *
 * ! ШИЙДВЭР (эзэмшигч эзгүй — анхдагч санал):
 * !   · НЭГ facet «Борлуулалтын баг (маршрут)», URL түлхүүр `salesManager` ХЭВЭЭР (холбоос, харагдац, drill эвдрэхгүй);
 * !   · сонголт = `/erp/routes`-тэй ЯГ ИЖИЛ эх сурвалж (API `ErpRouteCatalogService`) ∪ сүүлийн 400 хоногийн толгойн
 * !     хэрэглэгч; байгууллага × сувгаар БҮЛЭГЛЭНЭ (MPG_ROUTE_* ба Route* ХОЁУЛАА); борлуулалтгүй маршрут ч гарна;
 * !   · каталогт БАЙХГҮЙ толгойн хэрэглэгч «Маршрутгүй» бүлэг/мөрөөр ИЛ — чимээгүй хаягдахгүй;
 * !   · шүүлт баримтын толгойн Менеджерээр (тоо ӨӨРЧЛӨГДӨХГҮЙ);
 * !   · `manager` facet BI ба `/erp/1c-detail`-ээс ХАСАГДСАН (retired): API түүнийг зөвхөн ИЛ мэдэгдэл + санал болгох
 * !     багтай 400 `BI_FILTER_RETIRED`-ээр хариулна — ЧИМЭЭГҮЙ шүүхгүй, автоматаар хөрвүүлэхгүй (C7: KA +37…+211%);
 * !   · түвшин хэвээр: баг шүүх/задлах = Менежер (сувгийн дотор) / Pro; Basic хаалттай.
 *
 * ! ЦЭВЭР — React, Node, `Date` байхгүй (API ба админ хоёулаа импортлоно).
 */

/* ─────────────────────────── Түлхүүр ─────────────────────────── */

/** Нэгдсэн facet-ийн URL/API түлхүүр — ХЭВЭЭР (хуучин холбоос, харагдац, drill `/bi/sales/teams/{id}`). */
export const BI_SALES_TEAM_FACET = 'salesManager' as const

/**
 * ХАСАГДСАН facet (URL, харагдац, API). `BI_VIEW_QUERY_KEYS.sales` түүнийг ХЭВЭЭР агуулна — хуучин харагдац нээгдэж,
 * админ нэг удаа цэвэрлээд мэдэгдэл харуулна. API-д ирвэл 400 `BI_FILTER_RETIRED` (+ санал болгох баг).
 */
export const BI_RETIRED_FACET_KEYS = ['manager'] as const

export type BiRetiredFacetKey = (typeof BI_RETIRED_FACET_KEYS)[number]

/** Хасагдсан задаргааны хэмжээс (`/erp/1c-detail/breakdown?by=manager`) — 400 `BI_FILTER_RETIRED`, `by=salesManager` санал. */
export const BI_RETIRED_DIMENSIONS = ['manager'] as const

/** 400-ийн `code` — хасагдсан шүүлт/хэмжээс. */
export const BI_FILTER_RETIRED_CODE = 'BI_FILTER_RETIRED' as const

/* ─────────────────────────── «Маршрутгүй» ─────────────────────────── */

/**
 * «МАРШРУТГҮЙ» САВНЫ ТАНИХ ТЭМДЭГ — задаргааны `nonRoute` мөр (каталогт байхгүй толгойн хэрэглэгчид нэгтгэсэн).
 * ! URL-ийн утга БИШ (DTO нь зөвхөн жинхэнэ uuid хүлээнэ): drill нь `memberIds`-ээр (≤ `BI_NON_ROUTE_MAX_MEMBER_IDS`).
 */
export const BI_NON_ROUTE_ID = 'ffffffff-ffff-ffff-ffff-ffffffffffff'

/** «Маршрутгүй» мөрийн drill-д дамжуулах гишүүдийн дээд тоо (= facet-ийн `MAX_FACET_VALUES`). */
export const BI_NON_ROUTE_MAX_MEMBER_IDS = 50

/** Сонголтын идэвхийн цонх (хоног) — `BI_MAX_MONTHS = 13` сарыг бүрхэнэ. */
export const BI_SALES_TEAM_LOOKBACK_DAYS = 400

/** `/breakdown?by=salesManager&nonRoute=…` — `list` (анхдагч, API/AI) эсвэл `collapse` (BI-ийн багийн хавтан). */
export const BI_NON_ROUTE_MODES = ['list', 'collapse'] as const

export type BiNonRouteMode = (typeof BI_NON_ROUTE_MODES)[number]

/* ─────────────────────────── Маршрутын каталог ─────────────────────────── */

/**
 * `/erp/routes` каталогийн төлөв (сонголт, задаргаа, төлөвлөгөөний хариунд):
 *   `ok`        — bridge жагсаалтыг бүтэн өгсөн;
 *   `offline`   — уншигдсангүй (trade_dev: `_Fld29337` алга → bridge 500; bridge унтарсан; эсвэл ХООСОН жагсаалт). Сонголт = зөвхөн
 *                 идэвх (`route: null`), админ ИЛ туг харуулна; задаргааны `collapse` → `list`;
 *   `truncated` — `pagination.total` > буцаасан мөр (`pageSize: 500`-ийн хязгаар) — алдааны лог, `route` нь олдоогүйд `null`.
 */
export const BI_ROUTE_CATALOG_STATES = ['ok', 'offline', 'truncated'] as const

export type BiRouteCatalogState = (typeof BI_ROUTE_CATALOG_STATES)[number]

/* ─────────────────────────── Сонголт (`GET /erp/1c-detail/lookups`) ─────────────────────────── */

export type BiSalesTeamRef = { id: string; name: string }

/**
 * Сонголтын бүлгийн төрөл (дэлгэцийн хэсэг, энэ дарааллаар):
 *   `route`      — каталогт + идэвхтэй; байгууллага × сувгаар (`organization`, `channel`);
 *   `unverified` — каталог уншигдаагүй (`offline`/`truncated`) үеийн идэвхтэй хэрэглэгч; байгууллага × сувгаар;
 *   `idle`       — каталогт, 400 хоногт баримтгүй («Борлуулалтгүй (13 сар)»); байгууллагаар (нэрийн дүрэм → ХН, docs/31 §4x);
 *   `nonRoute`   — идэвхтэй ч каталогт БАЙХГҮЙ («Маршрутгүй»; үргэлж СҮҮЛД).
 */
export const BI_SALES_TEAM_GROUP_KINDS = ['route', 'unverified', 'idle', 'nonRoute'] as const

export type BiSalesTeamGroupKind = (typeof BI_SALES_TEAM_GROUP_KINDS)[number]

/**
 * БҮЛГИЙН БАЙГУУЛЛАГА ХААНААС ТОГТСОН (docs/31 §4x) — давуу эрэмбээр:
 *   `documents` — баримтын `Организация` (давамгай нь; баримттай бол ҮРГЭЛЖ энэ);
 *   `routeName` — баримтгүй маршрутын НЭРИЙН баримтжуулсан дүрэм (`MPG_…` → 1С-ийн «MPG» байгууллага);
 *   `hr`        — cloud ХН-ийн маршрутын ажилтны хуулийн этгээд (нэрийн дүрэмтэй ЗӨРЧИЛДӨХГҮЙ үед л);
 *   `null`      — тогтоогдсонгүй: `idle` бол админ «Байгууллага тодорхойгүй · Борлуулалтгүй» гэж ИЛ шошгоно; `nonRoute` үргэлж `null`.
 */
export const BI_SALES_TEAM_ORG_SOURCES = ['documents', 'routeName', 'hr'] as const

export type BiSalesTeamOrgSource = (typeof BI_SALES_TEAM_ORG_SOURCES)[number]

/**
 * Нэрийн дүрмээр тогтсон ч 1С (`_Reference146`, баримт) болон ХН-ээс uuid нь ТОДОРХОЙЛОГДООГҮЙ байгууллагын id-ийн угтвар
 * (`name:MPG`). uuid ЗОХИОХГҮЙ — шошго («MPG») ИЛ, id нь uuid биш гэдгээ илэрхийлнэ. Шүүлтийн утга БИШ (зөвхөн бүлэглэл).
 */
export const BI_UNRESOLVED_ORGANIZATION_ID_PREFIX = 'name:' as const

export type BiSalesTeamGroup = {
  kind: BiSalesTeamGroupKind

  /** Тогтвортой түлхүүр: `route:<orgId|->:<channelId|->`, `unverified:…`, `idle:<orgId|->`, `nonRoute`. */
  key: string

  /**
   * Баримтын `Организация` (`_Document358._Fld10985RRef` / `_Document279._Fld7173RRef`) — давамгай нь. `idle` (баримтгүй) →
   * docs/31 §4x-ийн дараалал (`organizationSource`): маршрутын нэрийн дүрэм (`MPG_…` → MPG) → cloud ХН-ийн маршрутын ажилтны
   * хуулийн этгээд (дүрэмтэй зөрчилдөхгүй бол) → `null`. `id` нь 1С `_Reference146` uuid; ЗӨВХӨН нэрийн дүрмийн байгууллага
   * 1С/ХН-д олдоогүй үед `name:<НЭР>` (`BI_UNRESOLVED_ORGANIZATION_ID_PREFIX`). `nonRoute` → `null`.
   */
  organization: BiSalesTeamRef | null

  /** `organization` хаанаас тогтсон (`BI_SALES_TEAM_ORG_SOURCES`); `null` — тогтоогдоогүй. Хуучин API-д алга байж болно. */
  organizationSource?: BiSalesTeamOrgSource | null

  /** Харилцагчийн `maxPrimarySalesChannel` — давамгай нь. `idle`/`nonRoute` → `null`. */
  channel: BiSalesTeamRef | null
}

/**
 * НЭГ СОНГОЛТ — `ErpRef` (`{id, name}`)-ийн ДЭЭД олонлог (хуучин клиент эвдрэхгүй).
 *
 * ! `id` — 1С uuid (`hexToUuid` байтын дараалал) = `/erp/routes`-ийн `id` = `salesManager=` утга (docs/31 §4w C1).
 */
export type BiSalesTeamOption = BiSalesTeamRef & {
  /** `true` — `/erp/routes` каталогт; `false` — каталогт алга («Маршрутгүй»); `null` — каталог уншигдаагүй. */
  route: boolean | null

  /** Давамгай байгууллага (баримтаас); баримтгүй маршрутад нэрийн дүрэм / cloud ХН-ээс (`group.organization`-тэй ижил), эс бөгөөс `null`. */
  organization: BiSalesTeamRef | null

  /** Давамгай суваг (харилцагчаас). Баримтгүй бол `null`. */
  channel: BiSalesTeamRef | null

  /** Хэрэглэгчийн БизнесРегион (`_Reference165._Fld26609RRef` → маршрутын дугаар «101»). */
  region: BiSalesTeamRef | null

  /** Сүүлийн баримтын өдөр `YYYY-MM-DD` (400 хоногт); баримтгүй бол `null`. */
  lastDay: string | null

  /** 400 хоногийн борлуулалт + буцаалтын толгойн тоо (эрэмбэ). */
  docs: number

  group: BiSalesTeamGroup
}

/** `GET /erp/1c-detail/lookups`-ийн багийн хэсэг. `salesManager` бусад facet-ээс ӨРГӨН хэлбэртэй. */
export type BiSalesTeamLookups = {
  salesManager: BiSalesTeamOption[]
  routeCatalog: BiRouteCatalogState

  /** Бүс → үндсэн менежерийн тоо (`BiRegionMainManagers`) — хасагдсан `manager`-ийн саналд. 1С тасарвал `{}`. */
  regionMainManagers: BiRegionMainManagers
}

/* ─────────────────────────── Задаргаа (`by=salesManager`) ─────────────────────────── */

/**
 * «МАРШРУТГҮЙ» МӨР — `nonRoute=collapse` үед каталогт байхгүй БҮХ толгойн хэрэглэгч НЭГ мөрөнд. Top-N-ээс ГАДУУР (хэзээ ч
 * «бусад»-д нуугдахгүй). `top + nonRoute + other = total`. `memberIds` — эхний ≤ 50 (drill `salesManager=<ids>`);
 * `members > memberIds.length` бол drill хийхгүй (tooltip).
 */
export type BiNonRouteBreakdown = {
  id: typeof BI_NON_ROUTE_ID
  value: number
  compareValue: number | null
  share: number | null
  members: number
  memberIds: string[]
}

/* ─────────────────────────── Хасагдсан `manager` ─────────────────────────── */

/** Нэг хасагдсан утга ба түүний оронд санал болгох баг(ууд). Автоматаар ХЭРЭГЛЭГДЭХГҮЙ. */
export type BiRetiredManagerItem = {
  id: string
  name: string | null
  suggestions: BiSalesTeamRef[]

  /**
   * Санал ХОЁР+ байгууллагын (Максимус / MPG) багийг хольсон эсэх — хасагдсан утгын байгууллага мэдэгдэхгүй (сонголтод алга)
   * үед л `true` болно. Админ «Бүгдийг нэмэх»-ийг НУУНА (нэг товшилтоор байгууллага холилдсон шүүлт үүсгэхгүй).
   */
  mixedOrganizations?: boolean
}

/**
 * 400 `BI_FILTER_RETIRED`-ийн `retired[]` мөр.
 *   `kind: 'filter'`    — `manager=<ids>`; `items` нь id бүрийн санал;
 *   `kind: 'dimension'` — `by=manager`; `items` хоосон, `by=salesManager` хэрэглэ.
 */
export type BiRetiredNotice = {
  key: BiRetiredFacetKey
  kind: 'filter' | 'dimension'
  replacement: typeof BI_SALES_TEAM_FACET
  items: BiRetiredManagerItem[]
}

export type BiFilterRetiredBody = {
  statusCode: 400
  error: 'Bad Request'
  code: typeof BI_FILTER_RETIRED_CODE
  message: string
  retired: BiRetiredNotice[]
}

/**
 * `GET /erp/1c-detail/lookups`-ийн `regionMainManagers` — хэрэглэгчийн БизнесРегион (uuid, жижиг үсэг) → тэр бүсийн
 * хэрэглэгчдээс хэдэн нь харилцагчийн `ОсновнойМенеджер` (`_Reference157._Fld3855RRef`, `_Marked = 0`) вэ.
 * trade_dev (2026-09-27): «101» → 1 (зөвхөн `Route101_Team1`), «331/332/333» → 2 (`_Team1` ба `_Team2` тус тусдаа).
 */
export type BiRegionMainManagers = Readonly<Record<string, number>>

type SuggestionOption = Pick<BiSalesTeamOption, 'id' | 'name' | 'route' | 'region'> &
  Partial<Pick<BiSalesTeamOption, 'organization' | 'channel' | 'group'>>

const orgOf = (option: SuggestionOption): string | null =>
  (option.organization?.id ?? option.group?.organization?.id ?? null)?.toLowerCase() ?? null

const channelOf = (option: SuggestionOption): string | null =>
  (option.channel?.id ?? option.group?.channel?.id ?? null)?.toLowerCase() ?? null

/**
 * ХАСАГДСАН `manager` УТГЫН ОРОНД САНАЛ БОЛГОХ БАГ — API (400-ийн бие) ба админ (нэг удаагийн мэдэгдэл) НЭГ дүрэм.
 *
 * ! Дүрэм (design §5):
 * !   1) хасагдсан хэрэглэгчийн БизнесРегион (сонголтоос, эсвэл `known`-оос) мэдэгдэж, тэр бүсийн ЦОРЫН ГАНЦ үндсэн менежер
 * !      бол (`regionMainManagers[бүс] ≤ 1`, эсвэл тоо мэдэгдэхгүй) → ТЭР бүсийн `route !== false` сонголтууд
 * !      (`Route101_Team1` → `Route101_Team1/2/3`);
 * !   2) бүсэд 2+ үндсэн менежер (жишээ нь «331»: `Route331_Team1` ба `_Team2` тус тусын харилцагчтай) → ЗӨВХӨН өөрөө (сонголтод байвал);
 * !   3) бүсгүй → өөрөө (сонголтод байвал); олдохгүй бол хоосон — таамаглахгүй;
 * !   4) БАЙГУУЛЛАГА: хасагдсан утгын болон нэр дэвшигчийн байгууллага ХОЁУЛАА мэдэгдэж, ялгаатай бол ХАСНА (docs/39:
 * !      `Route101_*` ба `MPG_ROUTE_101_*` нэг бүсэд байж болно — холивол хоёр хуулийн этгээдийн тоо нийлнэ). Баримтгүй
 * !      `MPG_…` маршрут нэрийн дүрмээр MPG байгууллагатай (docs/31 §4x) тул Максимусын утгад санал болгогдохгүй. Байгууллагагүй
 * !      нэр дэвшигч нь баримтгүй, дүрэм ч ХН ч тогтоогоогүй маршрут л — тоонд нөлөөгүй тул үлдэнэ. Хасагдсан утгын
 * !      байгууллага мэдэгдэхгүй бөгөөд санал 2+ байгууллагыг холивол `mixedOrganizations: true`;
 * !   5) СУВАГ: хоёулангийнх нь мэдэгдэж, ялгаатай бол хасна.
 * ! Нэрээр эрэмбэлнэ, давхардалгүй. ЗӨВХӨН САНАЛ: KA/RD/HO-д ялгаа их (docs/31 §4w C7) тул хэрэглэгч өөрөө баталгаажуулна.
 */
export const biRetiredManagerSuggestions = (
  ids: readonly string[],
  options: readonly SuggestionOption[],
  known: readonly { id: string; name: string | null; regionId: string | null }[] = [],
  regionMainManagers: BiRegionMainManagers | null = null
): BiRetiredManagerItem[] => {
  const byId = new Map(options.map(option => [option.id.toLowerCase(), option] as const))
  const knownById = new Map(known.map(entry => [entry.id.toLowerCase(), entry] as const))
  const unique = [...new Set(ids.map(raw => raw.trim().toLowerCase()).filter(id => id !== ''))]

  return unique.map(id => {
    const option = byId.get(id)
    const extra = knownById.get(id)
    const regionId = (option?.region?.id ?? extra?.regionId ?? null)?.toLowerCase() ?? null
    const name = option?.name ?? extra?.name ?? null
    const managers = regionId ? regionMainManagers?.[regionId] : undefined
    const soleManager = managers === undefined || managers <= 1
    const anchorOrg = option ? orgOf(option) : null
    const anchorChannel = option ? channelOf(option) : null

    const sameRegion =
      regionId && soleManager
        ? options.filter(candidate => {
            if (candidate.route === false || candidate.region?.id.toLowerCase() !== regionId) return false

            const org = orgOf(candidate)
            const channel = channelOf(candidate)

            if (anchorOrg && org && org !== anchorOrg) return false

            return !(anchorChannel && channel && channel !== anchorChannel)
          })
        : []

    const picked = sameRegion.length ? sameRegion : option ? [option] : []
    const distinct = [...new Map(picked.map(entry => [entry.id.toLowerCase(), entry] as const)).values()]
    const organizations = new Set(distinct.map(orgOf).filter((org): org is string => org !== null))

    const suggestions = distinct
      .map(entry => ({ id: entry.id.toLowerCase(), name: entry.name }))
      .sort((a, b) => a.name.localeCompare(b.name))

    return organizations.size > 1 ? { id, name, suggestions, mixedOrganizations: true } : { id, name, suggestions }
  })
}
